import MDinput from '@/components/MDinput';
import Select from '@/components/DSE/Select';
import { validatorRequire, validatorRequireNumber } from '@/utils/validators';

export function getFormDefinition(vue) {
  return {
    description: {
      type: MDinput,
      defaultValue: '',
      props: {
        maxlength: 32
      },
      rules: [{ validator: validatorRequire }]
    },
    domainID: {
      type: Select,
      defaultValue: vue.$store.getters['domain/getDefaultSelectValueDomainID'],
      props: {
        caption: 'common.domain',
        required: true,
        valueField: 'id',
        labelField: 'name',
        options: vue.$store.getters.domains
      },
      rules: [{ validator: validatorRequireNumber }]
    }
  };
}

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  return item;
}
